/**
 * Líné načtení vloženého iframu (mapa na Kontaktech)
 *
 * Proč vůbec: `loading="lazy"` u iframu je jen doporučení a prohlížeče ho
 * berou velmi volně — prvek v dosahu viewportu (a na mobilu je mapa na
 * Kontaktech hned pod hero) načtou OKAMŽITĚ. Google Maps si přitáhnou
 * vlastní balík skriptů a ten se vykonává v hlavním vlákně stránky:
 * v měření na Pixelu 7 (CPU 4×, 1,6 Mbps) přidal proti stavu bez mapy
 * zhruba stovku milisekund TBT v několika dlouhých úlohách, které
 * nepatřily nám ani Shoptetu (atribuce `cross-origin-descendant`).
 *
 * Řešení: `src` se do iframu nedostane z HTML, ale drží se v `data-src`
 * a dosadí se AŽ ve chvíli, kdy se prvek skutečně blíží viewportu
 * (IntersectionObserver s předstihem `rootMargin`). Do té doby je iframe
 * prázdný rámeček — rozměry mu dává CSS (`aspect-ratio`), takže
 * dosazení `src` nic neposune a vzhled je nerozeznatelný.
 *
 * Obecné, ne „mapa“: pracuje s každým `iframe[data-src]`, takže se to
 * samé dá použít pro další vložený obsah (video, kalendář) bez dalšího
 * skriptu.
 *
 * Bez JS / bez IntersectionObserveru zůstane iframe prázdný, proto je
 * pod mapou v HTML vždy i textový odkaz do navigace (html/kontakty.html)
 * — obsah tak není nikdy nedostupný.
 */
(function () {
	// O kolik dřív než na hraně viewportu se má začít načítat. 400 px
	// je zhruba půl obrazovky mobilu: uživatel k mapě doroluje a ona už
	// stojí, ale při načtení stránky se nespustí.
	var ROOT_MARGIN = '400px';

	function load(iframe) {
		var src = iframe.getAttribute('data-src');
		if (!src) return;
		iframe.removeAttribute('data-src');
		iframe.src = src;
	}

	function init() {
		var frames = document.querySelectorAll('iframe[data-src]');
		if (!frames.length) return;

		// Starý prohlížeč bez IntersectionObserveru: načti rovnou,
		// ať mapa nechybí. Zhoršené TBT je pořád lepší než prázdné místo.
		if (!('IntersectionObserver' in window)) {
			Array.prototype.forEach.call(frames, load);
			return;
		}

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					// Odpojit dřív než načíst — jinak by se při rychlém
					// rolování stihl callback vyvolat dvakrát.
					observer.unobserve(entry.target);
					load(entry.target);
				});
			},
			{ rootMargin: ROOT_MARGIN }
		);

		Array.prototype.forEach.call(frames, function (iframe) {
			observer.observe(iframe);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
